module.exports = __webpack_public_path__ + "static/graphQL@2x-b69e75dd6c6ca2be4ac78829e1f89283.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/developers/graphQL@2x.png
// module id = 2555
// module chunks = 168707334958949